<script>
  import crud from './Base/Crud'
  export default {
    mixins: [crud],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText:'新增Banner', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          editBtnText:'回复', // 新增按钮文案
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '反馈内容',
              prop: 'content',
              editDisplay: false,
              span: 24,
              overHidden: true,
              align: 'left',
              row: true
            },
            {
              label: '反馈人',
              prop: 'user-username',
              editDisplay: false,
              span: 24,
            },
            {
              label: '电话',
              prop: 'user-tel',
              editDisplay: false,
              span: 24,
            },
            {
              label: '部门',
              prop: 'user-class',
              editDisplay: false,
              span: 24,
            },
            {
              label: '反馈时间',
              prop: 'created_at',
              editDisplay: false,
              span: 24,
            },
            {
              label: '回复',
              prop: 'reply',
              rules: [{
                type: 'string', required: true, message: '回复输入不正确', trigger: 'blur'
              }],
              span: 24,
            },
            {
              label: '回复时间',
              prop: 'reply_time',
              editDisplay: false,
              span: 24,
            },
          ]
        }
      }
    }
  }
</script>
